module.exports = __webpack_public_path__ + "static/media/other.8467645b.svg";